import { ACTION_REWARD_FRIENDS_SUCCESS, ACTION_REWARD_FRIENDS, ACTION_REWARD_FRIENDS_ERROR } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const getRewardFriendsRequest = (access_token, url) => ({
    type: ACTION_REWARD_FRIENDS,
    payload: {
        access_token,
        url
    }
})

export const getRewardFriendsSuccess = data => ({
    type: ACTION_REWARD_FRIENDS_SUCCESS,
    payload: {
        data
    }
})


export const getRewardFriendsError = (msg) => ({
    type: ACTION_REWARD_FRIENDS_ERROR,
    payload: {
        msg
    }
})

export const getRewardFriends = (access_token, url) => {
    return dispatch => {
        dispatch(getRewardFriendsRequest(access_token, url))
        api.getRewardFriends(access_token, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getRewardFriendsError("error"));
                    return
                }

                const {lists} = data
                dispatch(getRewardFriendsSuccess(lists));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getRewardFriendsError("system error"))
            });
    }
}